import axios from "axios";
import { InternalAPIError } from "../../../../utils/apiErrors";
import { handleApiError } from "../../../../utils/globalErrorHandler";
import { getMSALAccessToken } from "../../../../services/getSecretKey";

const BASE_MKSAUTH_API_URL = process.env.REACT_APP_AUTHAPI_URL;

const BASE_MKSGROUPID = process.env.REACT_APP_GROUP_ID;

const SECRET_KEY = getMSALAccessToken();

const axiosApiInstance = axios.create({
  baseURL: BASE_MKSAUTH_API_URL,
});

axiosApiInstance.interceptors.request.use(
  async (config) => {
    if (SECRET_KEY) {
      config.headers.Authorization = `Bearer ${SECRET_KEY}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const getUsersData = async (isOwner, securityGroupId) => {
  try {
    const response = await axiosApiInstance.get(
      //`/usermanagement/getgroupmembers?groupId=${BASE_MKSGROUPID}&roleType=${
      `/usermanagement/getgroupmembersbyroletype?groupId=${securityGroupId || BASE_MKSGROUPID}&roleType=${isOwner ? "Owners" : "Members"
      }`
    );

    if (response.status === 200) {
      return response.data;
    } else {
      handleApiError(new InternalAPIError());
    }
  } catch (error) {
    handleApiError(new InternalAPIError());
  }
};

export const addUser = async (userName, SecurityGroupId, role) => {
  try {
    const response = await axiosApiInstance.post(
      `/usermanagement/addgroupusers?roleType=` + role,
      {
        GroupId: SecurityGroupId ? SecurityGroupId : BASE_MKSGROUPID,
        UserName: userName,
      }
    );
    if (response.status === 200 || response.status === 204) {
      return response.data;
    } else {
      handleApiError(new InternalAPIError());
    }
  } catch (error) {
    handleApiError(error);
  }
};

export const addBulkUsers = async (data, securityGroupId) => {
  try {
    const response = await axiosApiInstance.post(
      `/usermanagement/bulkaddgroupusers?groupId=${securityGroupId || BASE_MKSGROUPID}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status === 200 || response.status_code === 204) {
      return response;
    } else {
      handleApiError(new InternalAPIError());
    }
  } catch (error) {
    if (error?.response?.status >= 400 && error?.response?.status < 500) {
      return error?.response;
    } else {
      handleApiError(error);
    }
  }
};

export const bulkDeleteGroupUsers = async (data, securityGroupId) => {
  try {
    const response = await axiosApiInstance.post(
      `/usermanagement/bulkdeletegroupusers?groupId=${securityGroupId || BASE_MKSGROUPID}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status === 200 || response.status_code === 204) {
      return response;
    } else {
      handleApiError(new InternalAPIError());
    }
  } catch (error) {
    if (error?.response?.status >= 400 && error?.response?.status < 500) {
      return error?.response;
    } else {
      handleApiError(error);
    }
  }
};

export const getSecurityGroupRoleType = async (securityGroupId) => {
  try {
    const response = await axiosApiInstance.get(
      `/account/getuserroletype?group_id=${securityGroupId}`
    );
    if (response.status === 200 || response.status_code === 204) {
      return response?.data === "Owner" ? true : false;
    } else {
      handleApiError(new InternalAPIError());
    }
  } catch (error) {
    if (error?.response?.status >= 400 && error?.response?.status < 500) {
      return error?.response;
    } else {
      handleApiError(error);
    }
  }
};
